import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AuthPanel } from "@/components/auth/AuthPanel";

export const AuthModal = ({ open, onOpenChange, onSuccess, title = "Sign in to StayFlow", description = "Sign in or create your account to continue." }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl p-6" data-testid="auth-modal">
        <DialogHeader className="text-left">
          <DialogTitle className="font-heading font-extrabold text-2xl tracking-tight text-ink">{title}</DialogTitle>
          <DialogDescription className="text-ink-soft">{description}</DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <AuthPanel
            compact
            recaptchaId="sf-recaptcha-modal"
            onSuccess={(u) => { onSuccess?.(u); onOpenChange?.(false); }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuthModal;
